import styled from 'styled-components'

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #31363F;
  height: 40px;
  position: absolute;
  margin-top: 80px;
  width: 100%;
  font-family: 'Zilla Slab', sans-serif;
  color: #FFF;
  animation: show .5s cubic-bezier(.1,.82,.25,1);

  span {
    margin-right: 10px;
    display: flex;
    align-items: center;
    font-size: 16px;

    b {
      color: #64d2f2;
      margin: 0px 5px 0px -3px;
    }

    img {
      width: 30px;
      height: 20px;
      margin-left: -8px;
    }
  }

  @media (max-width: 495px) {
      span {
      font-size: 13px;
      flex-wrap: wrap;
      justify-content: center;
    }

  }
`